export function useTagSort() {
  function sort(tags: Array<any>) {
    const brancheTags = tags.filter((tag) => tag.parent?.slug === 'branche')
    const otherTags = tags.filter((tag) => tag.parent?.slug !== 'branche')
    return [...brancheTags, ...otherTags]
  }

  function group(tags: Array<any>) {
    const map = new Map()
    tags.forEach((tag) => {
      const key = tag?.parent?.parent?.slug || tag?.parent?.slug
      const collection = map.get(key)
      if (!collection) {
        map.set(key, [tag])
      } else {
        collection.push(tag)
      }
    })
    return Array.from(map.values())
  }

  function sortChildren(children) {
    if (
      children.some(
        (c) =>
          (c?.parent?.parent?.slug || c?.parent?.slug) === 'omvang-bedrijf',
      )
    ) {
      return sortCompanySize(children)
    } else {
      return children.sort((a, b) => {
        if (a.slug === 'overig') return 1
        if (b.slug === 'overig') return -1
        return a.slug.localeCompare(b.slug)
      })
    }
  }

  // Custom sorting for the strings based on numeric ranges
  function sortCompanySize(companies) {
    const regex = /(\d+)\s*-\s*(\d+)?/ // Adjusted regex for range matching
    const getValue = (str) => {
      const matches = str.match(regex)
      if (!matches) return Infinity
      const lower = parseInt(matches[1])
      const upper = matches[2] ? parseInt(matches[2]) : lower // If upper bound is not specified, use lower bound
      return (lower + upper) / 2 // Take the average for sorting
    }

    return companies.sort((a, b) => getValue(a.name) - getValue(b.name))
  }

  return {
    sort,
    group,
    sortChildren,
  }
}
